import React, { useState } from "react";

import { findId, findPassword } from "../../../api";
import { useNavigate } from "react-router-dom";
import CommonTitle from '../../../components/common-title/CommonTitle';

function FindAccount() {
  const navigate = useNavigate();
  // Find ID state
  const [findIdName, setFindIdName] = useState("");
  const [findIdEmail, setFindIdEmail] = useState("");
  const [findIdLoading, setFindIdLoading] = useState(false);
  const [findIdResult, setFindIdResult] = useState("");
  const [findIdError, setFindIdError] = useState("");

  // Find Password state
  const [fpNickname, setFpNickname] = useState("");
  const [fpName, setFpName] = useState("");
  const [fpEmail, setFpEmail] = useState("");
  const [fpLoading, setFpLoading] = useState(false);
  const [fpResult, setFpResult] = useState("");
  const [fpError, setFpError] = useState("");

  const handleFindId = async () => {
    // Field-specific alerts
    if (!findIdName.trim()) {
      alert('고객명을 입력하세요');
      return;
    }
    if (!findIdEmail.trim()) {
      alert('이메일을 입력하세요');
      return;
    }

    setFindIdLoading(true);
    setFindIdError("");
    setFindIdResult("");
    
    try {
      const res = await findId(findIdName.trim(), findIdEmail.trim());
      const data = res?.data;
      // Try to extract the user ID from common response shapes
      let foundId =
        (typeof data === 'string' ? data : null) ||
        data?.id ||
        data?.userId ||
        data?.nickname ||
        data?.username ||
        data?.result?.id ||
        data?.result;

      if (!foundId || typeof foundId !== 'string') {
        throw new Error('일치하는 회원 정보를 찾을 수 없습니다.');
      }

      navigate('/find-id-result', { state: { foundId } });
    } catch (err) {
      if (err?.response?.status === 404) {
        alert('존재하지 않습니다');
        setFindIdLoading(false);
        return;
      } else {
        alert("오류가 발생했습니다.");
        setFindIdLoading(false);

      }
    } finally {
      setFindIdLoading(false);
    }
  };

  const handleFindPassword = async () => {
    if (!fpNickname || !fpName || !fpEmail) {
      alert("모든 필드를 입력해주세요.");
      return;
    }
    
    setFpLoading(true);
    setFpError("");
    setFpResult("");
    
    try {
      const res = await findPassword(fpNickname.trim(), fpName.trim(), fpEmail.trim());
      const data = res?.data;
      
      // Extract user ID from the API response message
      let extractedUserId = fpNickname; // fallback to input
      
      if (typeof data === 'string' && data.includes('id(') && data.includes(')')) {
        // Extract ID from message like "User validated. Proceed with password reset for id(dynamic_data)"
        const idMatch = data.match(/id\(([^)]+)\)/);
        if (idMatch && idMatch[1]) {
          extractedUserId = idMatch[1];
        }
      } else if (data?.id || data?.userId || data?.result?.id) {
        // Try other common response formats
        extractedUserId = data.id || data.userId || data.result.id;
      }
      
      // Update the form to show the extracted user ID (trimmed)
      setFpNickname(extractedUserId.trim());
      
      
      // Show alert popup before navigation
      alert("비밀번호 분실 시 고객센터 1599-9442로 문의해 주시기 바랍니다.");
      setFpLoading(false);
      // Navigate to password reset page with the extracted user ID
      navigate('/find-account');
    } catch (err) {
      alert("존재하지 않습니다");
      setFpLoading(false);
      // return;
    } finally {
      setFpLoading(false);
    }
  };

  return (
      <div className="mobile-frame">
       <div className="container">
       <main className="signup-main-column find-acc-mobile">   
          <CommonTitle heading="아이디/비밀번호 찾기" />
       
          <div style={{ marginBottom: 32 }}>
            <div className="terms-title" style={{ margin: '24px 0 8px 0', fontSize: '1rem', fontWeight: 'bold', textAlign: 'left' }}>아이디 찾기</div>
            <div className="find-account-form" style={{ background: '#f7f7f7', padding: 16, borderRadius: 12, marginBottom: 24, maxWidth: '100%', margin: '0 auto' }}>
              <div className="form-group">
                <label>고객명</label>
                <input type="text" className="input" value={findIdName} onChange={e => setFindIdName(e.target.value)} />
              </div>
              <div className="form-group">
                <label>이메일</label>
                <input 
                  type="email" 
                  className="input" 
                  value={findIdEmail} 
                  onChange={e => setFindIdEmail(e.target.value.trim())} 
                  style={{ textIndent: '0', paddingLeft: '12px' }}
                />
              </div>
              {/* Inline error/result removed for Find ID; alerts are used instead */}
                             <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
                 <button className="next-btn" style={{ width: '39%', background: '#444', padding: '4px', color: '#fff' }} onClick={handleFindId} disabled={findIdLoading}>
                   {findIdLoading ? "찾는 중..." : "아이디 찾기"}
                 </button>
               </div>
            </div>
            <div className="terms-title" style={{ margin: '24px 0 8px 0', fontSize: '1rem', fontWeight: 'bold', textAlign: 'left' }}>비밀번호 찾기</div>
            <div className="find-account-form" style={{ background: '#f7f7f7', padding: 16, borderRadius: 12, maxWidth: '100%', margin: '0 auto' }}>
              <div className="form-group">
                <label>아이디</label>
                <input type="text" className="input" value={fpNickname} onChange={e => setFpNickname(e.target.value)} />
              </div>
              <div className="form-group">
                <label>고객명</label>
                <input type="text" className="input" value={fpName} onChange={e => setFpName(e.target.value)} />
              </div>
              <div className="form-group">
                <label>이메일</label>
                <input 
                  type="email" 
                  className="input" 
                  value={fpEmail} 
                  onChange={e => setFpEmail(e.target.value.trim())} 
                  style={{ textIndent: '0', paddingLeft: '12px' }}
                />
              </div>
              {fpError && <div className="error-msg">{fpError}</div>}
              {fpResult && <div className="success-msg">{fpResult}</div>}
                             <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
                 <button className="next-btn" style={{ width: '39%', background: '#444', padding: '4px', color: '#fff' }} onClick={handleFindPassword} disabled={fpLoading}>
                   {fpLoading ? "찾는 중..." : "비밀번호 찾기"}
                 </button>
               </div>
            </div>
          </div>
        </main>
        
      </div>
    </div>
  );
}

export default FindAccount; 